import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

interface MapsWrapperProps {
  children: React.ReactNode;
}

const render = (status: Status): React.ReactElement => {
  switch (status) {
    case Status.LOADING:
      return <h1>Loading Map...</h1>;
    case Status.FAILURE:
      return <h1>Error loading map</h1>;
    case Status.SUCCESS:
      return <></>;
    default:
      return <h1>Loading...</h1>;
  }
};

const MapsWrapper: React.FC<MapsWrapperProps> = ({ children }) => {
  return (
    <Wrapper
      apiKey={import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY || ""}
      render={render}
    >
      {children}
    </Wrapper>
  );
};

export default MapsWrapper;
